/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BSpinner, BForm, BFormGroup, BInputGroup, BInputGroupAppend, BFormInput, BButton,
} from 'bootstrap-vue'
import {
  resetpasswordrequired,
  resetpasswordrules,
  resetconfirmpasswordrequired,
  resetpasswordconfirm,
} from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
// import store from '@/store/index'
import { $themeConfig } from '@themeConfig'
import provider from '@/provider/provider'
import { NoSpace } from '@/libs/helpers'
import { CHANGE_PASSWORD } from '@/provider/url'
import { newAxiosIns } from '@/libs/axios'
import RecaptchaInvisible from '@core/components/recaptcha/RecaptchaInvisible.vue'

export default {
  components: {
    BCard,
    BButton,
    BForm,
    BFormGroup,
    BInputGroup,
    BFormInput,
    BSpinner,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    RecaptchaInvisible,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      // error: '',
      passwordNew: '',
      confirmedPassword: '',
      resetpasswordrequired,
      resetpasswordrules,
      resetconfirmpasswordrequired,
      resetpasswordconfirm,
      status: '',
      loading: false,
      successChanged: false,
      errorMessage: '',
      redirectSecs: 5,
      redirectTimer: null,
      // validation rules
      passwordFieldType: 'password',
      passwordConfirmationFieldType: 'password',
      NoSpace,
    }
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app

    return {
      // App Name
      appName,
      appLogoImage,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordConfirmationToggleIcon() {
      return this.passwordConfirmationFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },

  beforeDestroy() {
    clearInterval(this.redirectTimer)
  },
  methods: {
    togglePasswordConfirmationVisibility() {
      this.passwordConfirmationFieldType = this.passwordConfirmationFieldType === 'password' ? 'text' : 'password'
    },
    showmodal() {
      this.$refs['ubah-password'].toggle('#togggle-btn')
    },
    async submit() {
      this.loading = true
      this.errorMessage = ''
      try {
        const recaptchaToken = await this.$refs.recaptcha.execute('CHANGE_PASSWORD')
        await newAxiosIns.post(CHANGE_PASSWORD, {
          code: this.$route.query.code,
          password: this.passwordNew,
          recaptcha_token: recaptchaToken,
        })
        this.successChanged = true
        this.startRedirect()
      } catch (error) {
        const res = (error && error.response && error.response.data) || {}
        this.errorMessage = res.message || (res.meta && res.meta.message) || 'Terjadi kesalahan, silakan coba lagi'
      } finally {
        this.loading = false
      }
    },
    startRedirect() {
      this.redirectTimer = setInterval(() => {
        this.redirectSecs -= 1
        if (this.redirectSecs <= 0) {
          clearInterval(this.redirectTimer)
          this.$router.push('/login')
        }
      }, 1000)
    },
  },
}
